export default "__VITE_ASSET__BV931Big__"